"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const AssetCategories_1 = require("./AssetCategories");
const Assets_1 = require("./Assets");
// interface IState {}
class SalesforceApiExplorer extends react_1.default.Component {
    render() {
        const { integration } = this.props;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("h1", null, "Salesforce API Explorer"),
            react_1.default.createElement(Assets_1.Assets, { integration: integration }),
            react_1.default.createElement(AssetCategories_1.AssetCategories, { integration: integration })));
    }
}
exports.SalesforceApiExplorer = SalesforceApiExplorer;
//# sourceMappingURL=index.js.map